


@if (!maintenaceMode) {
  <router-outlet></router-outlet>
}
@if (maintenaceMode) {
  <app-maintenace-mode></app-maintenace-mode>
}


@if (loading) {
  <div class="progress-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
}


<app-modal-dialog [ngStyle]="{ 'display': displayErrorModal }" (navigate)="navigateToDashboard($event)"
[respDesc]="errorModalMessage"></app-modal-dialog>

